import React from 'react';
import { Box, Typography, Breadcrumbs, Link, Chip } from '@mui/material';
import GenericModal from '../GenericModal';
import { DrillDownConfig, DrillDownState, DrillDownActions } from '@/types/drillDown';

interface DrillDownModalProps<TData = any, TItem = any> {
  config: DrillDownConfig<TData, TItem>;
  state: DrillDownState<TData, TItem>;
  actions: DrillDownActions<TData, TItem>;
  children: React.ReactNode;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  fullWidth?: boolean;
}

export const DrillDownModal = <TData = any, TItem = any>({
  config,
  state,
  actions,
  children,
  maxWidth = 'xl',
  fullWidth = true
}: DrillDownModalProps<TData, TItem>) => {
  const { isModalOpen, loading, error, data, selectedItem } = state;
  const { closeModal, retry } = actions;

  const renderBreadcrumb = () => {
    if (!config.breadcrumbConfig || !data) return null;

    const breadcrumbItems = config.breadcrumbConfig.getBreadcrumbItems(data);
    
    return (
      <Box sx={{ mb: 2 }}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link
            component="button"
            variant="body2"
            onClick={closeModal}
            sx={{ cursor: 'pointer', textDecoration: 'none' }}
          >
            {config.breadcrumbConfig.label}
          </Link>
          {breadcrumbItems.map((item, index) => (
            <Typography key={index} color="text.primary" variant="body2">
              {item.label}
            </Typography>
          ))}
        </Breadcrumbs>
      </Box>
    );
  };

  const renderError = () => {
    if (!error) return null;

    return (
      <Box sx={{ p: 2, textAlign: 'center' }}>
        <Typography color="error" variant="body1" sx={{ mb: 2 }}>
          {error}
        </Typography>
        <Chip
          label="Tentar Novamente"
          onClick={retry}
          color="primary"
          variant="outlined"
          sx={{ cursor: 'pointer' }}
        />
      </Box>
    );
  };

  return (
    <GenericModal
      open={isModalOpen}
      onClose={closeModal}
      title={config.title}
      loading={loading}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
    >
      {renderBreadcrumb()}
      {error ? renderError() : children}
    </GenericModal>
  );
}; 